var _rect, _path, _path2, _path3, _path4, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 254,
    viewBox: "0 0 402 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 402,
    height: 254,
    fill: "#418DFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 47.5424H39M25 47.5424H18M41.0935 52.9957L38.0624 51.1779M25.938 43.9067L22.907 42.0889M26.75 56.9879L28.5 53.8394M35.5 41.2453L37.25 38.0968M37.25 56.9879L35.5 53.8394M28.5 41.2453L26.75 38.0968M22.9068 52.9957L25.9379 51.1779M38.0622 43.9067L41.0933 42.0889M32 77L32 54.8136M32 40.2712V33",
    stroke: "white",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M386 117H378M362 117H354M380.393 123L376.928 121M363.072 113L359.608 111M364 127.392L366 123.928M374 110.072L376 106.608M376 127.392L374 123.928M366 110.072L364 106.608M359.608 123L363.072 121M376.928 113L380.392 111M370 133L370 125M370 109V101",
    stroke: "white",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.743 25.2574L307.257 33.7426M315.743 33.7426L307.257 25.2573",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42V50M106 46L98 46",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 47,
    width: 8,
    height: 8,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.2
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3438,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(-45 20.3438 122)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitBackground);
export default __webpack_public_path__ + "static/media/benefit_background.b31e78ecbe856f763f1b2bfda1896bbb.svg";
export { ForwardRef as ReactComponent };